import React from "react";
import styled from "styled-components";

import { Container } from "./Container";

export const maxContainerWidth = 1080;

export const StyledLinkPageContainer = styled(Container)`
  align-items: center;
  max-width: ${maxContainerWidth}px;
  margin: 0 auto;
  padding: 0 40px;

  @media (max-width: 768px) {
    padding: 0 6%;
  }
`;

export function PageContainer({
  maxWidth = maxContainerWidth,
  children
}) {
  return (
    <StyledLinkPageContainer
      style={{
        maxWidth
      }}
    >
      {children}
    </StyledLinkPageContainer>
  );
}
